
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-is-covered",
      function () {
        return require("private-next-pages/what-is-covered/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-is-covered"])
      });
    }
  